/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';

export const SEASON = PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    permit_id: PropTypes.string,
    start_date: PropTypes.string,
    end_date: PropTypes.string,
    year: PropTypes.number,
});
